function Search() {
    const close = document.querySelector('.c-search .close')
    const input = document.querySelector('.c-search__input');

    if(close) {
        close.addEventListener('click', () => {
            closeWindow();
        })
    }

    const open = document.querySelector('.nav__search')
    if(open) {
        open.addEventListener('click', () => {
            document.body.classList.add('search-open');
            if(input) {
                input.focus();
            }
        })
    }

    const search = document.querySelector('.c-search');
    if(search) {
        search.addEventListener('click', e => {
            if(e.target.classList.contains('result') || e.target.parentElement.classList.contains('result')) {
                closeWindow();
            }
        })
    }

    const closeWindow = function() {
            document.body.classList.remove('search-open')
            if(input) {
                setTimeout(() => {
                    input.value = '';
                }, 500);
            }

    }
}

export default Search;
